import { IFacturaClienteAlumno, IFacturaClienteCuentaBanco } from "../../../../data/entidad/Factura"
import { _SvProcesaFacturaCatalogo } from "../../../../data/modulo/FacturaCatalogo"
import { _SvFacturaObtenerCatalogoSATFormaPago, _SvFacturaObtenerCatalogoSATUsoCFDI } from "../../../../data/modulo/FacturaCatalogoSAT"
import { DateV2 } from "../../../../util/DateV2"
import _L from "../../../../util/Labels"
import { FormGenerator } from "../../../controlD3/Formulario"
import { UIUtilTime } from "../../../util/Time"
import { IFacturaCFDIConceptosFiscalesProcesadosAdvanced } from "./FacturacionViewMovs"

export namespace UIUtilViewAlumnoEdoCtaFacturacionViewCFDIItem {

    export type CFDIItemForm = FormGenerator<ICFDIInfoItem> & {
        __SetClient?: (client: IFacturaClienteAlumno) => CFDIItemForm
        __SetContainer?: (container: TSelectionHTML) => CFDIItemForm
        __SetMovimientoPagosAgrupados?: (d: IFacturaCFDIConceptosFiscalesProcesadosAdvanced) => CFDIItemForm
        __GetMovimientoPagosAgrupados?: () => IFacturaCFDIConceptosFiscalesProcesadosAdvanced
    }

    export function CrearCFDIItemForm(idEscuela: number) {
        type TCuentaBanco = ({ key: string, name: string } & Partial<IFacturaClienteCuentaBanco>)
        let infoClienteFactura: IFacturaClienteAlumno
        let movimientoPagosAgrupados: IFacturaCFDIConceptosFiscalesProcesadosAdvanced

        const initData = <ICFDIInfoItem>{
            fechaTimbrado: "hoy",
            CuentaBanco: "0",
            EnviarCorreo: true,
        }
        const form: CFDIItemForm = new FormGenerator<ICFDIInfoItem>()

        const fnListaCuentas = () => {
            const listBase: TCuentaBanco[] = [{ key: "0", name: _L("general.ninguno") }]
            const listCuentas = infoClienteFactura?.cuentas_banco.map((cliente, i) => ({
                key: (i + 1) + "",
                name: `${cliente.banco} - ${cliente.cuenta}`,
                ...cliente,
            })) || []
            return [...listBase, ...listCuentas]
        }
        const camposCol1: (keyof ICFDIInfoItem)[] = ["fechaPago", "fechaTimbrado", "UsoCFDI", "FormaPago"]
        const camposCol2: (keyof ICFDIInfoItem)[] = ["NumOrder", "CondicionPago", "CuentaBanco", "Comentarios", "EnviarCorreo"]

        form._Crear({
            LabelWrap: false,
            OnLoad: (container, rows) => {
                container
                    .style("flex-direction", "row")
                    .style("gap", "var(--padding2)")
                    .call(cont => {
                        cont.append("div").call(div => camposCol1.forEach(c => div.append(() => rows.get(c).row.node())))
                            .style("width", "100%")
                        cont.append("div")
                            .call(div => camposCol2.forEach(c => {
                                div.append(() => rows.get(c).row.node())
                                    .select("label.titulos_base")
                                    .style("flex", "62%")
                            }))
                            .style("width", "100%")
                    })
            },
            schema: [
                { model: "fechaPago", type: "input", labelText: _L("panelfinanzasedocuenta.d_field_fechapago"), inputAttr: { required: true, removeBorder: true, disabled: true } },
                {
                    model: "fechaTimbrado", type: "selectMaterial", labelText: _L("panelfinanzasedocuenta_factura.fecha_cfdi"),
                    selectMaterialAttr: {
                        required: true,
                        valueMember: "key",
                        displayMember: "name",
                        Data: () => ObtenerFechaTimbradoOpciones(movimientoPagosAgrupados?.ConceptosFiscales[0]?.MovimientoFinanza[0]?.FechaPago, idEscuela),
                    }
                },
                {
                    model: "UsoCFDI", type: "selectMaterial", labelText: _L("panelfinanzasedocuenta_factura.uso_cfdi"),
                    selectMaterialAttr: {
                        required: true,
                        valueMember: "key",
                        displayMember: "name",
                        ShowAndEnableSearchText: true,
                        Data: _SvProcesaFacturaCatalogo(_SvFacturaObtenerCatalogoSATUsoCFDI(idEscuela)),
                    }
                },
                {
                    model: "FormaPago", type: "selectMaterial", labelText: _L("panelfinanzasedocuenta_factura.forma_pago"),
                    selectMaterialAttr: {
                        required: true,
                        valueMember: "key",
                        displayMember: "name",
                        Data: _SvProcesaFacturaCatalogo(_SvFacturaObtenerCatalogoSATFormaPago(idEscuela)),
                    },
                },
                { model: "NumOrder", type: "input", labelText: _L("panelfinanzasedocuenta_factura.num_orden") },
                { model: "CondicionPago", type: "input", labelText: _L("panelfinanzasedocuenta_factura.condicion_pago"), inputAttr: { maxlength: 1000 } },
                {
                    model: "CuentaBanco", type: "selectMaterial", labelText: _L("panelfinanzasedocuenta_factura.num_cuenta"),
                    selectMaterialAttr: {
                        valueMember: "key",
                        displayMember: "name",
                        Data: () => fnListaCuentas(),
                        onSelect: (item: TCuentaBanco) => {
                            form._DataOrigin.Banco = item?.banco || undefined
                            form._DataOrigin.Cuenta = item?.cuenta || undefined
                        }
                    }
                },
                { model: "Comentarios", type: "textArea", labelText: _L("panelfinanzasedocuenta_factura.comentarios"), inputAttr: { maxlength: 2000 } },
                { model: "EnviarCorreo", type: "input", labelText: _L("panelfinanzasedocuenta_factura.enviar_correo"), inputAttr: { type: "checkbox" } }
            ]
        }, initData);

        form.__SetClient = (cliente) => {
            if (!cliente)
                return form
            const clientChanged = infoClienteFactura?.UID != cliente.UID
            infoClienteFactura = cliente

            const cuentaControl = form._GetModelControl<"selectMaterial">("CuentaBanco")
            cuentaControl.instance._RefreshList()
            cuentaControl.row.classed("hide", !cliente.cuentas_banco?.length)

            if (clientChanged) {
                cuentaControl.instance._valueSelect(0) // reset
                form._SetModelValue("UsoCFDI", cliente.UsoCFDI)
            }
            return form
        }
        form.__SetContainer = (container) => {
            const formElement = form._Form.node()
            container.selectAll<HTMLFormElement, any>(":scope>.formulario_generator").each((_, i, elmts) => {
                if (formElement !== elmts[i])
                    elmts[i].remove()
            })
            if (formElement.parentElement != container.node())
                container.append(() => formElement)
            return form
        }
        form.__SetMovimientoPagosAgrupados = (data: IFacturaCFDIConceptosFiscalesProcesadosAdvanced) => {
            movimientoPagosAgrupados = data
            form._SetModelValue("fechaPago", data.FechaPagoFmt)

            const formaPagoControl = form._GetModelControl<"selectMaterial">("FormaPago").instance
            const formaPagoEnable = !data.ClaveFormaPagoSAT
            formaPagoControl._disabled = !formaPagoEnable
            formaPagoControl._ShowInputBorder(!formaPagoEnable)
            if (!form._GetModelValue("FormaPago"))
                form._SetModelValue("FormaPago", data.ClaveFormaPagoSAT)
            // else if (!formaPagoEnable)
            //     form._SetModelValue("FormaPago", "")

            const fechaTimbradoControl = form._GetModelControl<"selectMaterial">("fechaTimbrado").instance
            fechaTimbradoControl._RefreshList()

            return form
        }
        form.__GetMovimientoPagosAgrupados = () => movimientoPagosAgrupados
        return form
    }

    type TFechaTimbradoItem = { key: TFechaTimbrado, name: string, difDays: number }

    const FECHA_TIMBRADO_OPCIONES: { [k: number]: TFechaTimbradoItem } = {
        0: { difDays: 0, key: "hoy", name: _L("panelfinanzasedocuenta_factura.fechatimbrar_hoy") },
        1: { difDays: 1, key: "ayer", name: _L("panelfinanzasedocuenta_factura.fechatimbrar_ayer") },
        2: { difDays: 2, key: "antier", name: _L("panelfinanzasedocuenta_factura.fechatimbrar_antier") },
        3: { difDays: 3, key: "anteantier", name: _L("panelfinanzasedocuenta_factura.fechatimbrar_anteantier") },
    }

    export const FECHA_TIMBRADO_OPCIONES_BYKEY: { [k in TFechaTimbrado]: TFechaTimbradoItem } = {
        "hoy": FECHA_TIMBRADO_OPCIONES[0],
        "ayer": FECHA_TIMBRADO_OPCIONES[1],
        "antier": FECHA_TIMBRADO_OPCIONES[2],
        "anteantier": FECHA_TIMBRADO_OPCIONES[3],
    }

    function ObtenerFechaTimbradoOpciones(fechaPagoUTC: string, idEscuela: number) {
        let daysElapse = 0
        if (fechaPagoUTC) {
            const dt: DateV2 = new DateV2(fechaPagoUTC)._SetTimeZoneByIdSchool(idEscuela)._Truncate("Hour")
            const now = new DateV2()._Truncate("Hour")
            daysElapse = UIUtilTime._GetTimeElapsedSimple(dt, now).Days()
        }
        const result = <TFechaTimbradoItem[]>[]
        for (const k in FECHA_TIMBRADO_OPCIONES) {
            const nK: number = +k
            if (nK <= daysElapse)
                result.push(FECHA_TIMBRADO_OPCIONES[nK])
        }
        return result
    }

    type TFechaTimbrado = "anteantier" | "antier" | "ayer" | "hoy"


    export interface ICFDIInfoItem {
        fechaTimbrado: TFechaTimbrado
        fechaPago: string
        /** @example "01" */
        FormaPago: string
        /** @example "00110011" */
        ClaveProdServ: string
        /** NoOrdenPedido */
        NumOrder: string
        Fecha: string
        FechaExpedicion: string
        /** Nuero de cuenta */
        Cuenta: string
        CondicionPago: string
        UsoCFDI: string
        /** Auxiliar para campos `Banco` y `Cuenta` */
        CuentaBanco: string
        /** Banco de nuero de cuenta */
        Banco: string
        Comentarios: string
        EnviarCorreo: boolean
    }
}